import type { Namespaces } from 'bundles/epic/__generated__/namespaces';
import type { Module, ModuleType } from 'bundles/front-page/types';

export const isPureModule = (module: Module): module is ModuleType => typeof module === 'string';

export const getModuleType = (module: Module) => (isPureModule(module) ? module : module.type);
export const getModuleOptions = (module: Module) => (isPureModule(module) ? {} : module.options);

export const FrontpageVariants: {
  [K in Namespaces['localization']['loggedOutHomePageContent:global-global']]: readonly Module[];
} = {
  control: [
    'SKINNY_BANNER',
    'HERO',
    { type: 'PARTNERS', options: { showBackground: true } },
    'ONBOARDING',
    'CAREER_ROLES',
    'COLLECTIONS',
    'DOMAINS',
    { type: 'LEARNER_OUTCOMES', options: { hideEnterpriseCTA: true } },
    'TESTIMONIALS',
    { type: 'C4B_CTA', options: { showBackground: true } },
    { type: 'CONSUMER_CTA', options: { showBackground: false } },
  ],
  B: [
    'SKINNY_BANNER',
    'WIDER_HERO_REDESIGN',
    { type: 'PARTNERS', options: { showBackground: true } },
    'CAREER_ROLES',
    'COLLECTIONS',
    'DOMAINS',
    { type: 'LEARNER_OUTCOMES', options: { hideEnterpriseCTA: true } },
    'TESTIMONIALS',
    { type: 'C4B_CTA', options: { showBackground: true } },
    { type: 'CONSUMER_CTA', options: { showBackground: false } },
  ],
  C: [
    'SKINNY_BANNER',
    'WIDER_HERO_REDESIGN',
    { type: 'PARTNERS', options: { showBackground: true } },
    'CAREER_ROLES',
    'COLLECTIONS',
    'DOMAINS',
    { type: 'LEARNER_OUTCOMES', options: { hideEnterpriseCTA: true } },
    'TESTIMONIALS',
    { type: 'C4B_CTA', options: { showBackground: true } },
    { type: 'CONSUMER_CTA', options: { showBackground: false } },
  ],
} as const;
